import React from 'react';
import Button from '@dashboard/components/Button';
import classNames from 'classnames';

const ButtonComponent = ({ value }) => {
  const { link = {}, label = '', appearance = 'primary' } = value;

  if (link.linkType === 'internal') {
    if (link.reference.type === 'help-center-article') {
      const href = `/docs/articles/${link.reference.slug}`;
      return (
        <Button
          href={href}
          appearance={appearance}
          className={classNames({
            '!no-underline !text-white dark:!text-primary-foreground': appearance === 'primary',
            '!no-underline !text-black dark:!text-foreground': appearance === 'secondary',
          })}
        >
          {label}
        </Button>
      );
    } else if (link.reference.type === 'help-center-category') {
      const href = `/docs/${link.reference.slug}`;
      return (
        <Button
          href={href}
          appearance={appearance}
          className={classNames({
            '!no-underline !text-white dark:!text-primary-foreground': appearance === 'primary',
            '!no-underline !text-black dark:!text-foreground': appearance === 'secondary',
          })}
        >
          {label}
        </Button>
      );
    } else if (link.reference.type === 'blog-article') {
      const href = `/blog/${link.reference.slug}`;
      return (
        <Button
          href={href}
          appearance={appearance}
          className={classNames({
            '!no-underline !text-white dark:!text-primary-foreground': appearance === 'primary',
            '!no-underline !text-black dark:!text-foreground': appearance === 'secondary',
          })}
        >
          {label}
        </Button>
      );
    } else if (link.reference.type === 'blog-category') {
      const href = `/blog/topics/${link.reference.slug}`;
      return (
        <Button
          href={href}
          appearance={appearance}
          className={classNames({
            '!no-underline !text-white dark:!text-primary-foreground': appearance === 'primary',
            '!no-underline !text-black dark:!text-foreground': appearance === 'secondary',
          })}
        >
          {label}
        </Button>
      );
    } else {
      return label;
    }
  }

  return (
    <Button
      href={link.href}
      target={link.blank ? '_blank' : ''}
      appearance={appearance}
      className={classNames({
        '!no-underline !text-white dark:!text-primary-foreground': appearance === 'primary',
        '!no-underline !text-black dark:!text-foreground': appearance === 'secondary',
      })}
    >
      {label}
    </Button>
  );
};

export default ButtonComponent;
